import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SmsService } from '../services/sms.service';

@Component({
    selector: 'por-sms-verification',
    templateUrl: './sms-verification.component.html',
    styleUrls: ['./sms-verification.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SmsVerificationComponent {
    private readonly smsService = inject(SmsService);
    private readonly translateService = inject(TranslateService);
    private readonly cdr = inject(ChangeDetectorRef);

    @Input() userEmail!: string;
    @Input() organizationId!: string;
    @Input() storeName?: string;
    @Input() isUserDisabled = false; // Only show for disabled users
    @Input() showToggle = true; // Show "Use phone verification instead" toggle
    @Input() showEmailToggle = true; // Show "Use email verification instead" toggle

    showSmsSection = false;
    smsSending = false;
    smsMessage = '';
    smsDisabled = false;

    toggleSmsSection(): void {
        this.showSmsSection = !this.showSmsSection;
        this.smsMessage = '';
        this.cdr.markForCheck();
    }

    sendSmsCode(): void {
        if (this.smsSending || this.smsDisabled) {
            return;
        }

        this.smsSending = true;
        this.smsMessage = '';
        this.cdr.markForCheck();

        this.smsService.sendVerificationCode(this.userEmail, this.organizationId, this.storeName).subscribe({
            next: () => {
                this.smsSending = false;
                this.smsMessage = this.translateService.instant('Verification code sent to your phone!');
                this.cdr.markForCheck();
            },
            error: error => {
                this.smsSending = false;

                // 429 rate limiting
                // 404 email not found in RMS, which means phone number is not verified with email, so we block SMS sending to avoid abuse but show specific message to user
                if ([429, 404].includes(error.status)) {
                    this.smsDisabled = true;
                    const errorMessage = error?.error?.message;
                    this.smsMessage = errorMessage;
                } else {
                    this.smsMessage = this.translateService.instant('Failed to send SMS. Please try again.');
                }

                this.cdr.markForCheck();
            }
        });
    }
}
